
import { FilterMethod, FilterStringOptions, NUMBER_OPERATION_OPTIONS } from '@dbl/core/filter';
import { getMetricOptions } from '@dbl/core/dataSource';
import type { IColumnInfo } from '@dbl/core/dataSource';
import { checkNullString } from '../../../utils/utils';
import { dtStatDate } from './components/configuration';
import { DimensionType } from './components/Dimensions/Options/dimension_select';


export class NoticeBuilder {
  static buildFilter(filterBasic: any[], columnFilters: any[], filterLogic: number, props: any, isEn: boolean) {
    let noticeString = `${NoticeBuilder.innerBuildFilter(filterBasic, null, props, isEn)}`;
    noticeString = `${noticeString}${NoticeBuilder.innerBuildFilter(columnFilters, filterLogic, props, isEn)}`;
    if (!checkNullString(noticeString)) {
      
      noticeString = isEn ? `provide${noticeString.substring(0, noticeString.length - 1)}` : `在${noticeString.substring(0, noticeString.length - 1)}的条件下`;
    }
    return noticeString;
  }

  static innerBuildFilter(columnFilter: any[], logic: number|null, props: any, isEn: boolean) {
    const logicName =isEn ? (logic === 0 ? 'AND' : 'OR') : (logic === 0 ? '且' : '或');
    let html = '';
    html = columnFilter.reduce((previousValue, currentValue) => {
      const sb = BUILD_FILTER[currentValue.filter_method](currentValue, props, isEn);
      return `${previousValue}${logic === null ? "" : logicName}${sb}，`;
    }, html);
    return html;
  }

  static buildMetrics(columnMetrics: IColumnInfo[], isEn: boolean) {
    if (!columnMetrics || columnMetrics.length === 0) return '';
    let html = isEn ? "Using" :'以';
    html = columnMetrics.reduce((previousValue, currentValue) => {
      const method = getMetricOptions(currentValue.metric_method ?? 0, isEn).find((item: any) => item.value === currentValue.aggregate)?.text;
      const sb = `<span class='notice'>${isEn ? currentValue.column_display_en : currentValue.column_display}${method ? `(${method})` : ""}
      </span>`;
      return `${previousValue}${sb}`;
    }, html);
    html = `${html} ${isEn ? "as the indicator, " : "作为指标，"}`;
    return html;
  }

  static buildDimensions(columnDimensions: IColumnInfo[], columnFilterBasic: IColumnInfo[], isEn: boolean) {
    const dateFilter = columnFilterBasic.find((item) => item.column_name === dtStatDate);

    if (
      (!columnDimensions || columnDimensions.length === 0) &&
      (!dateFilter ||
        (dateFilter.column_granularity !== 'Day' &&
          dateFilter.column_granularity !== 'Week' &&
          dateFilter.column_granularity !== 'Month'))
    )
      return '';

    let html = isEn ? "broken down by" : '，按';

    let time = '';
    switch (dateFilter?.column_granularity) {
      case 'Day':
        time = isEn ? 'day' : '天';
        break;
      case 'Week':
        time = isEn ? 'week' : '周';
        break;
      case 'Month':
        time = isEn ? 'month' : '月';
        break;
    }
    if (time) {
      html = `${html}<span class='notice'>${time}</span>`;
    }

    const defaultColumnDimensions = columnDimensions.filter((item) => item.dimension_type === DimensionType.default);
    const rangColumnDimensions = columnDimensions.filter((item) => item.dimension_type === DimensionType.range);
    if (defaultColumnDimensions && defaultColumnDimensions.length > 0) {
      // html = `${html}`;
      html = defaultColumnDimensions.reduce((previousValue, currentValue) => {
        const sb = `<span class='notice'>${isEn ? currentValue.column_display_en : currentValue.column_display}</span>`;
        return `${previousValue}、${sb}`;
      }, html);
      // html = isEn ? `Discrete value for ${html}` : `${html}的离散值`;
      html = isEn ? `${html} discrete value for sub-dimension.` : `${html}的离散值`;
    }
    if (rangColumnDimensions && rangColumnDimensions.length > 0) {
      html = `${html}${time || (defaultColumnDimensions && defaultColumnDimensions.length > 0) ? '、' : ''}`;
      html = rangColumnDimensions.reduce((previousValue, currentValue) => {
        const sb = `<span class='notice'>${isEn ? currentValue.column_display_en : currentValue.column_display}</span>`;
        return `${previousValue}${sb}`;
      }, html);
      html = isEn ? `custom interval of ${html}` : `${html}的自定义区间`;
    }
    html = isEn ? `, ${html}. ` :`${html}进行分维度。`;
    return html;
  }
}

const BUILD_FILTER = {
  [FilterMethod.None]: buildFilterNone,
  [FilterMethod.Time]: buildFilterTime,
  [FilterMethod.County]: buildFilterCountry,
  [FilterMethod.String]: buildFilterString,
  [FilterMethod.Number]: buildFilterNumber,
  [FilterMethod.Package]: buildFilterPackage,
};

function buildFilterNone(column: any, props: any, isEn:boolean) {
  return `<span class='notice'>${isEn ? column.column_display_en : column.column_display}</span>`;
}

function buildFilterTime(column: any, _:any, isEn: boolean) {
  const word1 = isEn ? "from" : "为";
  const word2 = isEn ? "to" : "至";
  return `<span class='notice'>${isEn ? (column.column_display_en || "statistical time") : column.column_display}</span>${word1}<span class='notice'>${
    column.column_value?.[0] ?? ''
  }</span>${word2}<span class='notice'>${column.column_value?.[1] ?? ''}</span>`;
}

function buildFilterCountry(column: any, props: any, isEn: boolean) {
  return `<span class='notice'>${isEn ? column.column_display_en : column.column_display}</span>${isEn ? "is" : "是"}<span class='notice'>${column.column_text}</span>`;
}

function buildFilterString(column: any, props: any, isEn:boolean) {
  const opt = FilterStringOptions.find((it) => it.value === column.operation);
  return `<span class='notice'>${isEn ? column.column_display_en : column.column_display}</span><span class='notice'>${
    isEn ? opt?.text_en : opt?.text
  }</span><span class='notice'>${column.column_text}</span>`;
}

function buildFilterNumber(column: any, props: any, isEn:boolean) {
  let valueText = '';
  if (column.column_value?.length === 1) {
    valueText = `${column.column_value[0]}`;
  } else if (column.column_value?.length === 2) {
    valueText = `${column.column_value[0]}~${column.column_value[1]}`;
  }
  const opt = NUMBER_OPERATION_OPTIONS.find((it) => it.value === column.operation);
  return `<span class='notice'>${isEn ? column.column_display_en : column.column_display}</span><span class='notice'>${
    isEn ? opt?.text_en : opt?.text
  }</span><span class='notice'>${valueText}</span>`;
}

function buildFilterPackage(column: any, props: any, isEn:boolean) {
  const { columnSensitive } = props;
  const columnName = columnSensitive.find((item: any) => item.value === column.column_value?.[0])?.text ?? '';
  // 用户号码包相关数据不转换中英文
  return `<span class='notice'>${column.column_display}</span>${isEn ? "connect" : "关联"}<span class='notice'>${columnName}</span>`;
}
